import React, { Fragment, useContext, useState } from "react";
import styled from "styled-components";
import { qs } from "query-string";
import { ServiceTermsData } from "./ServiceTermsData";
import { NativeViewOpen } from "../../common/NativeViewOpen/NativeViewOpen";
import { AppContext } from "../../../components/AppProvider";
import { ServiceTerms_20231204 } from "./ServiceTerms/20231204";
import { ServiceTerms_20240415 } from "./ServiceTerms/20240408";

export default props => {
  const [timeSet, setTimeSet] = useState("20240415");
  const { userinfo, mypagecfg, auth, cfg, phonecfg, dispatch } =
    useContext(AppContext);
  return (
    <div>
      <div style={{ display: "flex" }}>
        <span className="tit">1. 이용약관</span>
        <select
          style={{ marginLeft: "8px" }}
          onChange={e => setTimeSet(e.target.value)}>
          <option value={"20240415"}>2024/04/15 ~</option>
          <option value={"20231220"}>2023/12/20 ~ 2024/04/15</option>
          <option value={"20230425"}>2023/04/25 ~ 2023/12/20</option>
          <option value={"HIST"}>2020/06/01 ~ 2023/04/25</option>
        </select>
      </div>
      {timeSet === "20240415" && <ServiceTerms_20240415 />}

      {timeSet === "20231220" && <ServiceTerms_20231204 />}

      {timeSet === "20230425" && (
        <div className="terms-txtarea">
          <div
            className="terms-area"
            style={{ resize: "none", overflow: "auto" }}>
            <div>
              {ServiceTermsData.map((data, i) => (
                <Sector key={"sector" + i}>
                  <SubTitle>{data.title}</SubTitle>

                  <div>
                    {data.content != "" && data.content}
                    {data.subContents.length > 0 &&
                      data.subContents.map((subData, z) => (
                        <SubContents key={"sector" + i + "sub" + z}>
                          {subData.text}

                          {subData.sub.length > 0 &&
                            subData.sub.map((datSub, y) => (
                              <SubContents
                                key={"sector" + i + "sub" + z + "_" + y}>
                                {datSub}
                              </SubContents>
                            ))}
                        </SubContents>
                      ))}
                  </div>
                </Sector>
              ))}
              <Sector>
                <SubTitle>부칙</SubTitle>
                <div>제1조(시행일)</div>
                {/* <div>본 약관은 2023.04.25부터 시행됩니다.</div> */}
                <div>본 약관은 2023.12.20부터 시행됩니다.</div>
              </Sector>
            </div>
          </div>
        </div>
      )}

      <Sector style={{ marginTop: "60px" }}>
        <SubTitle>개정이력</SubTitle>
        <div
          style={{ textDecoration: "underline" }}
          onClick={() =>
            NativeViewOpen(
              phonecfg.phoneOS,
              "https://pado.mdpeople.co.kr/#/mp/termsWebView/service20231220"
            )
          }>
          2023년12월20일
        </div>
        <div
          style={{ textDecoration: "underline" }}
          onClick={() =>
            NativeViewOpen(
              phonecfg.phoneOS,
              "https://pado.mdpeople.co.kr/#/mp/termsWebView/service"
            )
          }>
          2023년04월25일
        </div>
      </Sector>
    </div>
  );
};

export const ContentsService = () => {
  return (
    <ServiceTerms_20240415 />
  );
};
// export const ContentsService = () => {
//   return (
//     <div>
//       {ServiceTermsData.map((data, i) => (
//         <Sector key={"sector" + i}>
//           <SubTitle>{data.title}</SubTitle>

//           <div>
//             {data.content != "" && data.content}
//             {data.subContents.length > 0 &&
//               data.subContents.map((subData, z) => (
//                 <SubContents key={"sector" + i + "sub" + z}>
//                   {subData.text}

//                   {subData.sub.length > 0 &&
//                     subData.sub.map((datSub, y) => (
//                       <SubContents key={"sector" + i + "sub" + z + "_" + y}>{datSub}</SubContents>
//                     ))}
//                 </SubContents>
//               ))}
//           </div>
//         </Sector>
//       ))}
//       <Sector>
//         <SubTitle>부칙</SubTitle>
//         <div>제1조(시행일)</div>
//         {/* <div>본 약관은 2023.04.03부터 시행됩니다.</div> */}
//         <div>본 약관은 2023.12.20부터 시행됩니다.</div>
//       </Sector>
//     </div>
//   );
// };

const Sector = styled.div`
  margin-bottom: 8px;
`;

const SubTitle = styled.div`
  font-weight: 700;
`;

const SubContents = styled.p`
  margin-left: 8px;
`;

export const ServiceTermsHist = (props) => {
  return (
    <div>
      <div className="terms-txtarea">
        <div
          className="terms-area"
          style={{ resize: "none", overflow: "auto" }}>
          <pre style={{ whiteSpace: "pre-wrap" }}>
            {`서비스 이용약관
1. 제1조 (목적)
본 이용약관은 “케어포미”(이하 "(주)미라벨소프트")에서 제공하는 서비스의 이용조건과 운영에 관한 제반사항 규정을 목적으로 합니다.
각종 웹사이트, SMS, API, 알림, 이메일, 애플리케이션, 데이타를 비롯한 서비스(“서비스” 또는 “케어포미”)뿐만 아니라 본 서비스상에서 업로드 또는 다운로드 되거나 보여지는 정보, 문구, 그래픽, 사진 또는 기타 자료(이하 통칭하여 “콘텐츠”)에 액세스하여 이를 이용하는 행위 일체를 규정합니다.
2. 제2조 (용어의 정의)
1. 본 약관에서 사용되는 주요한 용어의 정의는 다음과 같습니다.
(1) 서비스:  접속 가능한 유∙무선 단말기(PC, TV, 휴대형단말기 등의 각종 유무선 장치를 포함)의 종류와는 상관없이 이용 가능한 "회사"가 제공하는 모든 "서비스"를 의미합니다.
(2) 이용자: 회사 서비스에 접속하여, 이 약관에 따라 회사가 제공하는 서비스를 이용하는 회원과 비회원을 말합니다.
(3) 회원 : 사이트의 약관에 동의하고 개인정보를 제공하여 회원등록을 한 자로서, 사이트와의 이용계약을 체결하고 사이트를 이용하는 이용자로 개인 또는 기업을 말합니다.
(4) 아이디 : "회원"의 식별과 "케어포미 서비스" 이용을 위하여 "회원"이 정하고 "회사"가 승인하는 문자와 숫자의 조합을 이메일 또는 간편로그인 계정을 의미합니다.
(5) 비밀번호 : 회원이 사용하는 이메일과 일치하는 회원임을 확인하고 회원의 비밀 보호를 위해 회원 자신이 설정한 문자와 숫자의 조합을 말합니다.
(6) 이용계약 : 사이트 이용과 관련하여 사이트와 회원간에 체결 하는 계약을 말합니다.
(7) 회원 아이디(이하 "ID") : 회원의 식별과 회원의 서비스 이용을 위하여 회원별로 부여하는 고유한 문자와 숫자의 조합을 말합니다.
(8) 비밀번호 : 회원이 부여받은 ID와 일치된 회원임을 확인하고 회원의 권익보호를 위하여 회원이 선정한 문자와 숫자의 조합을 말합니다.
(9) 탈퇴 : 회사 또는 회원이 서비스 개통 후 이용계약을 해약하는 것을 말합니다.
(10) 콘텐츠 : 회사가 제작 또는 회원이 업로드 하거나, 제휴사가 제공하는 동영상, 이미지, 텍스트 등 전부를 말합니다.
(11) 운영자 : 서비스에 홈페이지를 개설하여 운영하는 운영자를 말합니다.
(12) 해지 : 회원이 이용계약을 해약하는 것을 말합니다.
(13) 데이타 : “사용자”의 시스템 정보 (운영 체제 정보, “제품”의 버전, 에러 정보, 전화번호, 이메일), 개인진료기록 및 영상자료(회원 동의 하에 수락한 정보)의 정보를 말합니다.
2. 이 약관에서 사용하는 용어 중 제1항에서 정하지 아니한 것은 관계 법령 및 서비스 별 안내에서 정하는 바에 따르며, 그 외에는 일반 관례 및 상거래 관행에 따릅니다.
3. 제 3 조 (약관의 효력 및 변경)
1. 본 약관은 본 서비스 이용 회원에 대하여 적용됩니다.
2. 본 약관은 서비스 화면에 온라인으로 게시하거나 기타 유사한 방법으로 고지하고 이용자가 동의함으로써 효력이 발생합니다.
3. 회사는 합리적인 사유가 있는 경우 이 약관을 관계법령에 위배되지 않는 범위 내에서 변경할 수 있으며, 약관이 변경된 경우에는 회사는 지체 없이 전항의 방식 또는 기타 이와 유사한 방법으로 고지하며, 고지한 때로부터 변경된 약관이 효력을 발생합니다.
4. 회원은 전항에 의한 약관변경에 동의하지 않을 경우 회원 탈퇴(해지)를 요청할 수 있습니다. 다만, 회원이 변경된 약관의 효력발생일 이후에도 1월 이상 본건 서비스를 계속 사용할 경우에는 약관의 변경에 동의한 것으로 간주됩니다.
4. 제 4 조 (약관 외 준칙)
1. 본 약관에 명시되지 않은 사항은 전기통신기본법, 전기통신사업법, 독점규제 및 공정거래에 관한 법률(이하 “공정거래법”), 컴퓨터 프로그램 보호법, 저작권법 등 관계법령 및 회사가 제공하는 서비스에 관한 별도의 약관, 이용규정 또는 세부이용지침 등의 규정에 따릅니다.
2. 회사는 유료서비스 및 개별 서비스에 대해서는 별도의 이용약관 및 정책을 둘 수 있으며, 해당 내용이 본 약관과 상충할 경우에는 그러한 별도의 이용약관 및 정책이 우선하여 적용됩니다.
5. 제 5 조 (회원에 대한 통지)
1. 회사는 e-mail이나 문자메시지(SMS/MMS), 애플리케이션 알림(PNS)의 발송, 기타 적절한 통신수단을 이용하여 회원에 대한 통지를 할 수 있습니다.
2. 회사는 전항에 의한 통지가 불가능한 불특정다수 회원 또는 이용자에 대한 통지의 경우 서비스 게시판 등에 관련 내용을 상당 기간 게시함으로써 개별 통지에 갈음할 수 있습니다.
제 2 장 서비스 이용 계약
6. 제 6 조 (이용계약의 성립)
1. 회원이 서비스 화면을 통하여 회사가 고지하는 본 약관에 "동의합니다" 버튼을 클릭하거나 선택하는 경우 본 약관에 동의한 것으로 간주합니다.
2. 본 서비스의 이용 계약은 아래 제7조에 의한 고객의 가입신청에 대하여 회사가 승낙함으로써 성립합니다.
3. "회사"는 다음 각 호에 해당하는 신청에 대해서는 승낙을 하지 않거나 사후에 이용 계약을 해지할 수 있습니다.
• 실명이 아니거나 타인의 명의를 이용한 경우
• 허위의 정보를 기재하거나, "회사"가 제시하는 내용을 기재하지 않은 경우
• "회원"의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우
4. 제1항에 따른 신청에 있어 "회사"는 전문기관을 통한 "회원"의 실명확인 및 본인인증을 요청할 수 있습니다.
5. "회사"는 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을유보할 수 있습니다.
6. "회원"의 가입신청을 승낙을 하지 아니하거나 유보한 경우, "회사"는 원칙적으로 이를 "회원"에게 알리도록 합니다. 이용계약의 성립 시기는 "회사"가 가입완료를 신청절차 상에서 표시한 시점으로 합니다.
7. "회사"는 "회원"에 대해 회사정책에 따라 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 이용에 차등을 둘 수 있습니다.
7. 제 7 조 (가입신청 및 승낙)
1. 이용계약은 회원이 되고자 하는 자(이하 “가입신청자”)가 약관의 내용에 대하여 동의를 한 다음 회원가입 신청을 하고 회사가 이러한 신청에 대하여 승낙함으로써 체결됩니다.
2. 회원으로 가입하기 위해서는 본 약관 동의, 개인정보 관련 제반 동의, 기타 서비스 관련 동의 절차를 거친 후 회사가 정한 양식에 따라 아이디(ID), 패스워드(password), 이동전화 번호, 닉네임, 이동전화단말기정보, e-mail, 성명, 성별, 주소, 추천인, 사진, 유선전화번호 등 기타 회사가 필요하다고 인정하는 사항을 기입하여야 합니다.
3. 회원은 서비스 이용을 위해 등록할 경우 현재의 사실과 일치하는 완전한 정보(이하 "등록정보")를 제공하여야 하고, 회원은 본 조 제1항의 등록사항이 변경되었을 경우 회원정보 변경 등 회사가 정한 절차에 따라 이를 수정해야 할 의무가 있습니다. 회원이 회원정보를 변경하지 않음으로써 발생하는 문제에 대하여 회사는 책임을 지지 않습니다.
4. 모든 회원은 반드시 회원 본인의 정보를 제공하여야만 서비스를 이용할 수 있으며, 타인의 정보를 도용하거나 허위 정보를 등록하는 등 본인의 정보를 정확히 등록하지 않은 회원은 본 약관에 따라 해지 등 불이익을 받을 수 있으며, 관계 법령에 따라 처벌 받을 수 있습니다. 
5. 회원 가입은 본인의 정보를 통하여만 가입할 수 있으며, 회사는 회원이 등록한 정보에 대하여 확인조치를 할 수 있습니다. 회원은 회사의 확인조치에 대하여 적극 협력하여야 하며, 만일 이를 이행하지 아니할 경우 회사는 회원이 등록한 정보를 부정확한 것으로 처리할 수 있습니다. 
6. 회사는 회원에 대하여 회사가 정한 기준 또는 등급별로 구분하여 이용시간, 이용회수, 서비스 메뉴, 이벤트 참여 등을 세분하여 이용에 차등을 둘 수 있습니다. 
회사는 가입신청자의 신청에 대하여 서비스 이용을 승낙함을 원칙으로 합니다. 다만, 회사는 다음7. 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
① 가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 단 회사의 회원 재가입 승낙을 얻은 경우에는 예외로 함.
② 실명이 아니거나 타인의 명의를 이용한 경우
③ 허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우
④ 14세 미만 아동이 법정대리인(부모 등)의 동의를 얻지 아니한 경우
⑤ 이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우
⑥ 제1항에 따른 신청에 있어 회사는 회원의 종류에 따라 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.
⑦ 회사는 서비스관련설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.
⑧ 제2항과 제4항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, 회사는 원칙적으로 이를 가입신청자에게 알리도록 합니다.
⑨ 이용계약의 성립 시기는 회사가 가입완료를 신청절차 상에서 표시한 시점으로 합니다.
⑩ 회사는 회원에 대해 회사정책에 따라 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 이용에 차등을 둘 수 있습니다.
8. 제 8 조 (이용자ID 부여 및 변경 등) 
1. 회사는 회원에 대하여 약관이 정하는 바에 따라 이용자 ID를 부여합니다.
2. 이용자ID는 변경이 불가하며 부득이한 사유로 인하여 변경하고자 하는 경우에는 해당 ID에 의한 회원 가입을 해지하고 재가입해야 합니다.
3. 케어포미의 이용자ID는 회원 본인의 동의 하에 기관, 회사 또는 자회사가 운영하는 스마트폰 애플리케이션 또는 웹사이트의 회원ID와 연결될 수 있습니다. 
4. 이용자ID는 다음 각 호에 해당하는 경우에는 회원의 요청 또는 회사의 직권으로 변경 또는 이용을 정지할 수 있습니다. 
① 이용자ID가 전화번호 또는 주민등록번호 등으로 등록되어 사생활 침해가 우려되는 경우 
② 타인에게 혐오감을 주거나 미풍양속에 어긋나는 경우 
③ 회사, 회사의 서비스 또는 서비스 운영자 등의 명칭과 동일하거나 오인 등의 우려가 있는 경우 
④ 기타 합리적인 사유가 있는 경우 
5. 이용자ID 및 비밀번호의 관리책임은 회원에게 있습니다. 이를 소홀이 관리하여 발생하는 서비스 이용상의 손해 또는 제3자에 의한 부정이용 등에 대한 책임은 회원에게 있으며 회사는 그에 대한 책임을 지지 않습니다. 
6. 기타 회원 개인정보 관리 및 변경 등에 관한 사항은 서비스 별 안내에서 정하는 바에 의합니다. 
9. 제 9 조 (개인정보의 보호 및 사용) 
1. 회사는 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 또한, 개인정보보호법, 정통망법 등 관계법령이 전하는 바에 따라서 회원의 개인정보를 보호하기 위해 노력하며, 개인정보의 보호 및 이용에 대해서는 관련 법령 및 회사의 개인정보 보호정책이 적용됩니다. 단, 회사의 공식 사이트 이외의 링크된 사이트에서는 회사의 개인정보 보호정책이 적용되지 않습니다. 또한, 회원은 비밀번호 등이 타인에게 노출되지 않도록 철저히 관리해야 하며 회사는 회원의 귀책사유로 인해 노출된 정보에 대해서 책임을 지지 않습니다. 
2. 회사는 다음과 같은 경우에 법이 허용하는 범위 내에서 회원의 개인정보를 제3자에게 제공할 수 있습니다.
① 회원 가입시 허용한 병원 및 협력업체  
② 수사기관이나 기타 정부기관으로부터 정보제공을 요청 받은 경우 
③ 회원의 법령 또는 약관의 위반을 포함하여 부정행위 확인 등의 정보보호 업무를 위해 필요한 경우 
④ 기타 법률에 의해 요구되는 경우
3. 회사는 회원의 정보 수집 시 반드시 당해 회원의 동의를 얻어 필요한 최소한의 정보만을 수집하며, 회원은 온라인을 통해서 수시로 본인의 신상정보를 열람, 정정 또는 삭제할 수 있습니다.
제 9조의 2 (계측기(Sensing Device) 연동 서비스에 관한 특칙)
1. 회원은 본 서비스 가입 후 회사가 지정한 계측기(회원의 혈당, 혈압, 심박수, 운동량, 몸무게 등자가건강관리)를 측정하고 이와 연관된 건강관리 데이타를 측정할 수 있는 소정의 서버로 전송하는 장치를 말합니다)를 구매하여 본 서비스와 연동되게 할 수 있습니다. 
2. 회사는 계측기에 의하여 측정된 정보를 사용자로부터 별도의 동의를 받아, 동의받은 범위내에서 제휴회사, 법인, 단체, 기관 등에 제공할 수 있습니다.
10. 제 10 조 (서비스 승낙의 제한)
1. 회사는 다음의 각 호에 해당하는 이용신청에 대해 승낙을 하지 않을 수 있으며, 해당 사유가 해소될 때까지 승낙을 유보할 수 있습니다.
① 기술 상 서비스 제공이 불가능한 경우
② 다른 사람의 명의사용 등 이용자가 허위 정보로 신청하는 경우
③ 신청 시 필요한 사항을 허위로 기재하거나 중대한 사항에 기재누락, 오기가 있는 경우
④ 사회의 안녕질서 또는 미풍양속을 저해하거나, 저해할 목적으로 신청한 경우
⑤ 부정한 방법으로 서비스를 이용하여 회사에 피해를 줄 수 있다고 판단되는 경우
⑥ 이전에 부정 이용 등으로 인하여 회원 자격을 상실한 적이 있는 경우. 다만, 동 자격 상실 이후 1년 이상 경과한 자로 회사의 회원 재가입 승낙을 받은 경우는 예외로 합니다.
⑦ 서비스 관련 설비 용량이 부족한 경우
⑧ 영리를 추구할 목적으로 본 서비스를 이용하고자 하는 경우
⑨ 서비스와 경쟁관계에 있는 이용자가 신청하는 경우
⑩ 기타 회사가 정한 이용신청 요건이 만족되지 않았거나 회사의 사정상 필요하다고 인정되는 경우
2. 회사는 회원가입 이후에 제1항의 사유가 있음을 알게 된 경우, 이용계약의 해지, 중단 등 이용제한 조치를 취할 수 있습니다.
3. 회사는 이용신청고객이 관계 법령에서 규정하는 미성년자일 경우에 서비스 별 안내에서 정하는 바에 따라 승낙을 유보할 수 있습니다. 
4. 회사는 회원 가입 절차 완료 이후 제1항 각 호에 따른 사유가 발견된 경우 이용 승낙을 철회할 수 있습니다.
제 3 장 서비스의 이용
11. 제 11 조 (서비스 이용)
1. 회사는 회원 가입 시부터 즉시 서비스를 개시합니다. 단, 일부 서비스에 한해 지정된 일자부터 서비스를 개시할 수 있습니다.
2. 회사의 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는 경우에는 사이트에 공지하거나 회원에게 이를 통지합니다.
3. 회사는 모바일 단말기(아이폰 OS 단말기, 안드로이드 OS 단말기 등) 전용 애플리케이션을 제공하며, 회원은 회사에서 허용하는 범위 내의 단말기에서 전용 애플리케이션을 다운받고 설치하여 본 서비스를 이용할 수 있습니다. 단, 단말기의 종류 및 회원이 가입한 통신사에 따라 애플리케이션의 구성과 기능에는 차이가 있을 수 있습니다.
12. 제 12 조 (서비스 이용 시간) 
1. 서비스는 회사의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간 운영을 원칙으로 합니다. 단, 회사는 시스템 정기점검, 증설 및 교체를 위해 회사가 정한 날이나 시간에 서비스를 일시 중단할 수 있으며, 예정되어 있는 작업으로 인한 서비스 일시 중단은 제5조에서 정한 방법을 통해 사전에 공지합니다. 
2. 운영시간 또는 운영기간이 정해진 일부 서비스는 1일 24시간이 아닌, 별도로 정해진 기준에 따라 운영됩니다. 별도로 정해진 기준은 제5조에서 정한 방법을 통해 사전에 공지합니다. 
3. 회사는 긴급한 시스템 점검, 증설 및 교체, 설비의 장애, 서비스 이용의 폭주, 국가비상사태, 정전 등 부득이한 사유가 발생한 경우 사전 예고 없이 일시적으로 서비스의 전부 또는 일부를 중단할 수 있습니다. 
4. 회사는 서비스 개편 등 서비스 운영 상 필요한 경우 회원에게 사전 예고 후 서비스의 전부 또는 일부의 제공을 중단할 수 있습니다.
13. 제 13 조 (서비스 내용)
1. 본 서비스는 회사가 제시하는 형태에 맞춰 식사 및 운동기록과 자가측정 값, 기타 건강정보를 입력할 수 있는 기능, 외부 제휴된 활동량 측정기에 연동하여 운동량을 자동으로 입력할 수 있는 기능, 입력한 내용을 바탕으로 회원간의 경쟁 및 커뮤니케이션을 위한 랭킹, 커뮤니티 서비스, 회사가 제시하는 조건에 따라 음식과 음식점을 검색할 수 있는 기능, 회원 별 추천 음식 및 음식점 정보, 일반적인 질환 정보를 제공합니다. 
2. 본 서비스는 사진, 텍스트로 입력된 식사 기록에 대한 분석과 해당 기록을 바탕으로 한 어드바이스 서비스를 무료 또는 유료로 제공합니다.
3. 본 서비스는 회원에게 유형, 무형의 상품을 쇼핑몰을 통해 유료로 제공합니다. 
4. 본 서비스는 각종 이벤트를 운영하며, 회원 등급 또는 회원이 사용중인 상품에 따라 차등 제공합니다. 
14. 제 14 조 (서비스의 변경 및 제한)
1. 회사는 변경될 서비스의 내용 및 제공일자를 제5조에서 정한 방법으로 회원에게 통지하고 서비스를 변경하여 제공할 수 있습니다.
2. 회사는 다음 각 호에 해당하는 경우 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다.
① 컴퓨터 등 정보통신설비의 보수점검•교체 및 고장, 통신의 두절 등의 사유가 발생한 경우
② 서비스를 위한 설비의 보수 등 공사로 인해 부득이한 경우
③ 정전, 제반 설비의 장애 또는 서비스 이용의 폭주 등으로 정상적인 서비스가 불가능할 경우
④ 회원이 회사의 영업활동을 방해하는 경우
⑤ 서비스 제공업자와의 계약종료 등 회사의 제반 사정으로 서비스를 유지할 수 없는 경우
⑥ 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우
⑦ 회사의 사업계획의 변경 또는 경영상의 사유로 더 이상의 서비스 제공이 불가능할 경우
3. 본 조 제2항에 의한 서비스 중지의 경우에는 회사는 제5조에서 정한 방법으로 회원에게 통지합니다. 단, 회사가 통제할 수 없는 사유로 인한 서비스의 중단(운영자의 고의•과실이 없는 디스크 장애, 시스템 장애 등)으로 인하여 사전 통지가 불가능한 경우에는 그러하지 아니합니다.
4. 회사는 회사에 고의 또는 과실이 없는 경우에는 서비스의 변경, 중지로 발생하는 문제에 대해서 책임을 지지 않습니다.
15. 제 15 조 (게시물 관리)
1. 회원의 게시물이 정보통신망 이용 촉진 및 이용자 보호 등에 관한 법률(이하 정통망법) 및 저작권법 등 관련법에 위반되는 내용을 포함하는 경우, 권리자는 관련법에 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 등을 요청할 수 있으며, 회사는 관련법에 따라 조치를 취하여야 합니다.
2. 회사는 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 게시물에 대한 게재중단 등의 임시조치를 취할 수 있습니다.
3. 회사는 회원이 작성한 게시물이 다음 각 호의 경우에 해당한다고 판단되는 경우 해당 게시물을 삭제할 수 있으며, 그 게시물의 양과 성격에 따라 서비스 이용 중지 또는 회원자격의 제한을 할 수 있습니다.
① 회사의 서비스를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 경우
② 회원의 게시물이 정통망법 및 저작권법 등 관련법에 위반되는 내용을 포함하는 경우
③ 관련법이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 요청이 들어 온 경우
④ 음란물을 포함하거나 음란사이트를 연결(링크)하는 경우
⑤ 공공질서 및 미풍양속에 위반되는 내용인 경우
⑥ 서비스와 관련된 설비의 오작동이나 정보 등의 파괴 및 혼란을 유발시키는 내용, 컴퓨터 바이러스 감염자료를 등록 또는 유포하는 경우
⑦ 영리를 목적으로 하는 광고성 정보일 경우
⑧ 회사에서 공식적으로 인정한 서비스 이외의 서비스를 이용하여 상품을 판매하는 영업 활동, , 광고를 통한 수익, 음란사이트를 통한 상업행위, 상용소프트웨어 불법배포, 해킹을 하는 경우
⑨ 법률에 의하거나 계약상 또는 위임에 의하여 전송할 수 있는 권리가 없는 내용을 게시, 게재, e-mail 또는 기타 방법으로 전송하거나 공개하는 경우
⑩ 본 약관에 따른 회원의 의무에 위반되거나, 게시판의 성격에 부합하지 않는 경우
⑪ 기타 관계법령에 위배된다고 판단되는 경우
16. 제 16 조 (게시물 및 장소정보의 저작권)
1. 회사가 작성하여 애플리케이션, 사이트 또는 서비스에 게시한 저작물의 저작권은 회사에 귀속됩니다.
2. 회원이 서비스 내에서 작성한 게시물(회원간 전달 포함)의 저작권은 해당 회원이 소유하며, 해당 게시물에 대한 책임도 회원에게 있습니다.
3. 회원이 서비스 내에서 작성한 게시물은 작성자가 설정한 범위 내에서 다른 회원에게 공유될 수 있습니다.
4. 회사는 회원이 작성한 장소(위치)정보 및 장소 정보에 대한 정보를 회원의 동의를 얻어 제휴업체에게 제공할 수 있습니다.
5. 회사는 작성한 회원의 동의 없이 게시물을 다른 목적으로 사용할 수 없습니다.
6. 회원이 등록한 게시물에 대하여 저작권 분쟁이 발생할 경우 이에 대한 책임은 회원이 부담하며 회사는 이에 대하여 책임을 지지 않습니다. 회원이 타인의 저작권 등을 침해하였음을 이유로 회사가 타인으로부터 손해배상청구 등 이의 제기를 받은 경우 회원은 회사의 면책을 위하여 노력하여야 하며, 회사가 면책되지 못한 경우 회원은 회사의 귀책부분을 초과하여 회사에 발생한 손해를 부담하여야 합니다.
7. 회사는 특정 회원에 대한 본건 서비스 관련 이용계약이 적법하게 해지된 경우 해당 회원의 게시물을 삭제할 수 있습니다.
① 회사의 서비스를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 경우
② 회원의 게시물이 정통망법 및 저작권법 등 관련법에 위반되는 내용을 포함하는 경우
③ 관련법이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 요청이 들어 온 경우
④ 음란물을 포함하거나 음란사이트를 연결(링크)하는 경우
⑤ 공공질서 및 미풍양속에 위반되는 내용인 경우
⑥ 서비스와 관련된 설비의 오작동이나 정보 등의 파괴 및 혼란을 유발시키는 내용, 컴퓨터 바이러스 감염자료를 등록 또는 유포하는 경우
⑦ 영리를 목적으로 하는 광고성 정보일 경우
⑧ 회사에서 공식적으로 인정한 서비스 이외의 서비스를 이용하여 상품을 판매하는 영업 활동, , 광고를 통한 수익, 음란사이트를 통한 상업행위, 상용소프트웨어 불법배포, 해킹을 하는 경우
⑨ 법률에 의하거나 계약상 또는 위임에 의하여 전송할 수 있는 권리가 없는 내용을 게시, 게재, e-mail 또는 기타 방법으로 전송하거나 공개하는 경우
⑩ 본 약관에 따른 회원의 의무에 위반되거나, 게시판의 성격에 부합하지 않는 경우
⑪ 기타 관계법령에 위배된다고 판단되는 경우
8. 회원은 서비스에 게시된 자료 또는 서비스를 이용하여 얻은 정보를 회사의 사전승낙 없이 복제, 송신, 출판, 배포, 방송 및 기타 방법에 의해 영리목적으로 이용하거나 제3자에게 이용하게 할 수 없으며, 게시물에 대한 지식재산권 침해는 관계법령의 적용을 받습니다.
17. 제 17 조 (정보의 제공, 광고의 게재 및 하이퍼링크)
1. 회사의 타 업체와 사업 제휴, 사업 양도, 회사의 분할, 합병 시 회원의 정보는 공유될 수 있습니다.
2. 회사는 광고를 포함하여 다양한 정보를 공지사항, 전자 우편, 핸드폰 문자 메시지(SMS, MMS, PUSH), 우편 등의 방법으로 회원에게 제공할 수 있습니다.
3. 회사는 본 서비스의 운용과 관련하여 서비스 화면 등에 회사가 지정하는 위치에 광고 등을 게재할 수 있습니다.
4. 회원은 회사에서 제공하는 광고에 대한 임의 삭제, 비방, 기타 방해 행위 등을 할 수 없습니다.
5. 회사는 게시자가 게시한 게시물 중 하이퍼링크 등으로 연결된 사이트가 독자적으로 제공하는 재화•용역에 대한 회원의 거래에 대해서 보증 책임을 지지 않습니다.
18. 제 18 조 (서비스 재판매 금지)
회원은 상업적인 목적을 위하여 본 서비스 자체, 서비스 내용의 일부 또는 전부를 복사, 복제, 판매, 재판매 또는 양수도하는 방법으로 이용 할 수 없습니다.
19. 제 19 조 (이벤트 경품 등)
1. 회사는 회원을 위한 경품, 포인트 적립 등의 행사를 단기간 또는 지속적으로 시행할 수 있으며 행사 진행의 방법에 따라 선정되는 회원(수혜자 또는 당첨자)에게 회사가 정한 현금, 상품, 쿠폰 등(이하 "경품 등")을 제공할 수 있습니다.
2. 본 조 제1항에 의한 경품 등을 지급할 경우, 발생하는 제세공과금과 입금수수료 등 제반 비용은 당첨된 회원이 부담해야 하며, 회사는 사전 공지합니다. 단, 회사가 별도로 이에 대한 세칙 등을 공지한 경우에는 해당 조건을 따릅니다.
3. 행사 방법에 따라 수혜자 또는 당첨자로 선정된 회원에 대한 경품 등의 지급방식은 회사에서 정하는 방법에 따르며, 회사는 당해 회원의 승낙을 받고 회사의 상황에 따라 사전에 회사가 정한 경품 등의 내용 및 지급 방법 등을 변경하여 제공할 수 있습니다.
4. 수혜자 또는 당첨자로 선정된 회원이 선정 확정 후 회사가 정하는 일정 기간이 지나도 경품 등을 수령하지 않거나 배송 후 주소불명 등으로 반송된 경우에는 경품 등의 수령을 포기한 것으로 인정하여 선정을 취소할 수 있습니다.
5. 회사는 수혜자 또는 당첨자로 선정된 회원의 개인정보가 허위로 밝혀지거나 해당 회원이 관련 세칙을 준수하지 않았을 경우에는 선정을 취소할 수 있습니다.
6. 회사는 외부업체와의 공동 제휴 및 운영 위탁을 통해 이벤트를 유치하여 회원에게 경품을 제공할 수 있습니다. 단 이벤트를 제공한 외부업체의 사정으로 이벤트 경품의 변경 또는 배송지연 등이 발생할 경우 회사는 이에 대한 책임을 지지 아니합니다.
20. 제 20 조 (포인트 적립, 소멸 등)
1. 회사는 회원이 ‘케어포미 App.’ 내에서 포인트를 적립하는 정책에 따라 적정한 행위를 수행할 경우 회원에게 일정한 포인트를 부여할 수 있습니다.
2. 부여된 포인트는 부여일로부터 1년간 유효합니다. 다만, 회사가 별도로 유효기간을 정한 때에는 이에 따르며, 유효기간이 경과한 포인트는 자동적으로 소멸하게 됩니다.
제 4 장 당사자의 의무
21. 제 21 조 (회사의 의무)
1. 회사는 서비스 제공과 관련하여 알게 된 회원의 개인정보를 본인의 승낙 없이 제3자에게 누설, 배포하지 않습니다. 단, 관계법령에 의한 수사상의 목적으로 관계기관으로부터 요구 받은 경우나 주무관청의 요청이 있는 경우 등 법률의 규정에 따른 적법한 절차에 의한 경우에는 그러하지 아니합니다. 
2. 회사는 계속적이고 안정적인 서비스 제공을 위하여 관련 설비 및 소프트웨어에 장애가 발생한 때에는 부득이한 사유가 없는 한 지체 없이 이를 수리 또는 복구합니다. 다만, 천재지변, 비상사태 또는 그밖에 부득이한 경우에는 그 서비스를 일시 중단하거나 중지할 수 있습니다.
3. 회사는 서비스와 관련한 회원의 불만사항이 접수되는 경우 이를 신속하게 처리하며, 신속한 처리가 곤란한 경우 그 사유와 처리 일정을 제5조의 방법으로 동 회원에게 통지합니다.
4. 회사가 제공하는 서비스로 인하여 회원에게 손해가 발생한 경우 그러한 손해가 회사의 귀책사유에 기해 발생한 경우에 한하여 회사에서 책임을 부담합니다.
5. 회사는 개인정보보호법, 정통망법, 통신비밀보호법, 전기통신사업법 등 서비스의 운영, 유지와 관련 있는 법규를 준수합니다.
22. 제 22 조 (회원의 의무)
1. 회원은 서비스를 이용할 때 다음 각 호의 행위를 하여서는 아니 됩니다.
① 본건 서비스를 제공받기 위해 이용 신청 또는 변경 시 허위 사실을 기재하거나, 다른 회원의 ID 및 비밀번호를 도용, 부정하게 사용하는 행위
② 회사의 서비스를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위
③ 타인의 명예를 손상시키거나 불이익을 주는 행위, 타인으로 가장하는 행위 및 타인과의 관계를 허위로 명시하는 행위
④ 게시판 등에 음란물을 게재하거나 음란사이트를 연결(링크)하는 행위
⑤ 회사의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 행위
⑥ 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형, 음성 등을 유포하는 행위
⑦ 서비스와 관련된 설비의 오작동이나 정보 등의 파괴 및 혼란을 유발시키는 컴퓨터 바이러스 감염 자료를 등록 또는 유포하는 행위
⑧ 서비스 운영을 고의로 방해하거나 서비스의 안정적 운영을 방해할 수 있는 정보를 전송하거나 수신자의 명시적인 수신 거부 의사에 반하여 광고성 스팸 정보를 전송하는 행위
⑨ 관련 법령에 의하여 전송 또는 게시가 금지되는 정보(컴퓨터 프로그램 포함)의 전송 또는 게시 행위
⑩ 적법한 절차에 의하지 않고 다른 회원의 개인정보를 수집, 저장, 공개하는 행위
⑪ 자기 또는 타인에게 재산상의 이익을 주거나 타인에게 손해를 가할 목적으로 허위의 정보를 유통시키는 행위
⑫ 도박이나 사행행위를 조장하는 행위 및 윤락행위를 알선하거나 음행을 매개하는 내용의 정보를 유통시키는 행위
⑬ 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나 e-mail로 발송하는 행위
⑭ 수치심이나 혐오감 또는 공포심을 일으키는 말이나 음향, 글이나 화상 또는 영상을 계속하여 상대방에게 도달하게 하여 상대방의 일상적 생활을 방해하는 행위
⑮ 스토킹(stalking) 등 다른 회원을 괴롭히는 행위 등 기타 불법적이거나 부당한 행위
⑯ 기타 관계 법령에 위배되거나 공서양속에 반하는 행위
2. 회원은 관계 법령, 본 약관의 규정, 이용안내 및 서비스상에 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 아니 됩니다.
3. 회원은 회사에서 공식적으로 인정한 경우를 제외하고는 서비스를 이용하여 상품을 판매하는 영업 활동을 할 수 없으며, 특히 해킹, 광고를 통한 수익행위, 음란사이트를 통한 상업행위, 상용소프트웨어 불법배포 등을 할 수 없습니다. 이를 위반하여 발생한 영업 활동의 결과 및 손실, 관계기관에 의한 처벌 등 법적 조치 등에 관해서는 회사가 책임을 지지 않으며, 회원은 이와 같은 행위와 관련하여 회사가 입은 손해에 대하여 배상 의무를 집니다.
23. 제 23 조 (ID(고유번호) 및 비밀번호(password), 이동전화번호에 대한 회원의 의무)
1. 회원은 서비스 가입시 통신사 개인인증을 확인 후, 회원이 등록한 회원 ID(고유번호) 및 비밀번호(password)를 등록합니다. 회사는 회원의 회원 ID(고유번호), 회원 비밀번호(password), 이동전화번호 관리를 철저히 하여야 합니다.  
2. 회원은 본인의 ID(고유번호) 및 비밀번호(password), 이동전화번호를 제3자에게 이용하게 해서는 안됩니다.
3. 회원이 본인의 ID(고유번호) 및 비밀번호(password), 이동전화번호를 도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 회사에 이를 통보하고 회사의 안내가 있는 경우에는 그에 따라야 합니다.
4. 회원 ID(고유번호)와 비밀번호(password), 이동전화번호의 관리 소홀, 부정 사용에 의하여 발생하는 모든 결과에 대한 책임은 회원 본인에게 있으며, 회사의 시스템 고장 등 회사의 책임 사유로 발생하는 문제에 대해서는 회사가 책임을 집니다.
5. 회원의 ID(고유번호)는 회사의 사전 동의 없이 변경할 수 없습니다.
6. 회원은 이동전화번호 변경 시 회사에 알릴 의무가 있습니다. 또한, 회원은 이동전화번호 변경시 회원이 “케어포미.APP”에서 전화번호를 변경해야 합니다. 
24. 제 24 조 (개인정보 보호)
회사는 회원의 개인정보 보호를 매우 중요시하며, 개인정보보호법, 정통망법 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 이용에 대해서는 관련법 및 회사의 개인정보처리방침이 적용됩니다.
단, 회원의 귀책사유로 인해 노출된 정보에 대해 운영자는 일체의 책임을 지지 않습니다.
운영자는 회원이 미풍양속에 저해되거나 국가안보에 위배되는 게시물 등 위법한 게시물을 등록 · 배포할 경우 관련기관의 요청이 있을시 회원의 자료를 열람 및 해당 자료를 관련기관에 제출할 수 있습니다.
25. 제 25 조 (개인위치정보의 보호)
회사는 “위치정보의 보호 및 이용 등에 관한 법률” 등 관계 법령이 정하는 바에 따라 회원의 개인위치정보를 보호하기 위해 노력합니다. 개인위치정보의 보호 및 이용에 관해서는 관련법 및 회사의 개인정보처리방침이 적용됩니다. 
26. 제 26조 (개인위치정보의 이용 또는 제공) 
(1) “회사”는 개인위치정보주체로부터 동의를 받아 이용한 개인위치정보를 이용하여 서비스를 제공할 수 있으며, 구체적인 내용은 아래와 같습니다.
가) 사업자 정보
ㄱ) 상호: 주식회사 미라벨소프트
ㄴ) 주소: 서울특별시 서초구 효령로 304 국제전자센터 11층 11054호
ㄷ) 전화번호: 1877-4872
ㄹ) 이메일 주소: mirabellsoft@mdpark.co.kr
나) 서비스의 내용
이용자 위치 또는 검색한 위치 주변의 병원과 약국을 거리 순에 따라 노출
다) 개인위치정보 이용방법
이용자의 동의를 득한 뒤 이용자가 서비스 이용에 사용 중인 단말기의 GPS 기능을 통해 이용자의 위치정보를 이용
(2) "회원" 및 법정대리인의 권리와 그 행사 방법은 제소 당시 이용자의 주소에 의하며, 주소가 없는 경우 거소를 관할하는 지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자인 경우에는 민사소송법상의 관할법원에 제기합니다.
(3) "회사"는 위치정보의 보호 및 이용 등에 관한 법률 제16조 제2항에 근거하여 타 사업자 또는 이용 고객과의 요금정산 및 민원처리를 위해 위치정보 이용 제공 사실 확인자료를 자동 기록 보존하며, 분쟁발생 시 조정 등을 위해 해당 자료는 1년간 보관합니다.
(4) "회사"는 개인위치정보를 "회원"이 지정하는 제3자에게 제공하는 경우 개인위치정보를 이용한 당해 통신 단말 장치로 매회 회원에게 제공받는 자, 제공일시 및 제공목적을 즉시 통보합니다. 단, 아래 각호의 1에 해당하는 경우에는 회원이 미리 특정하여 지정한 통신 단말장치 또는 전자우편 주소로 통보합니다.
가) 개인위치정보를 이용한 당해 . 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우
나) 회원이 온라인 게시 등의 방법으로 통보할 것을 미리 요청한 경우
27. 제27조(개인위치정보주체의 권리)
(1) "회원"은 "회사"에 대하여 언제든지 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의의 전부 또는 일부를 철회할 수 있습니다. 이 경우 회사는 이용한 개인위치정보 및 위치정보 이용, 제공사실 확인자료를 파기합니다.
(2) "회원"은 "회사"에 대하여 언제든지 개인위치정보의 이용 또는 제공의 일시적인 중지를 요구할 수 있으며, 회사는 이를 거절할 수 없고 이를 위한 기술적 수단을 갖추고 있습니다.
(3) "회원"은 "회사"에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 당해 자료에 오류가 있는 경우 그 정정을 요구할 수 있습니다. 이 경우 "회사"는 정당한 사유 없이 회원의 요구를 거절할 수 없습니다.
가) 본인에 대한 위치정보 이용, 제공사실 확인자료
나) 본인의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률 규정에 의하여 제3자에게 제공된 이유 및 내용
(4) "회원"은 제1항 내지 제3항의 권리행사를 위해 회사에 소정의 절차를 통해 요구할 수 있습니다.
28. 제 28 조 (법정대리인의 권리)
(1) "회사"는 14세 미만의 회원에 대해서는 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의를 당해 회원과 당해 회원의 법정대리인으로부터 동의를 받아야 합니다. 이 경우 법정대리인은 제18조에 의한 회원의 권리를 모두 가집니다.
(2) "회사"는 14세 미만의 아동의 개인위치정보 또는 위치정보 이용 제공사실 확인자료를 이용약관에 명시 또는 고지한 범위를 넘어 이용하거나 제3자에게 제공하고자 하는 경우에는 14세 미만의 아동과 그 법정대리인의 동의를 받아야 합니다. 단, 아래의 경우는 제외합니다.
가) 위치정보 및 위치기반서비스 제공에 따른 요금정산을 위하여 위치정보 이용, 제공사실 확인자료가 필요한 경우
나) 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우
29. 제 29 조 (통계정보의 가공과 제공)
"회사"는 "회원"으로부터 수집한 개인 정보 및 서비스 이용기록을 통계학적 방법으로 정리, 분석하여 "통계 자료"로만 가공하며, 가공한 '통계 자료'의 저작권 및 소유권, 기타 모든 지적재산권은 모두 '회사'가 소유합니다.
30. 제 30 조 (통계 분석 자료의 제공)
제 15조 각 호에 해당하는 "통계 자료"는 "회원" 또는 다음 각 호에 해당하는 자에게 제공되어 활용될 수 있습니다.
병원
요양기관
제약사
학계
공공기관
기타 일반 기업
"회사"는 가공된 '통계 자료'를 사용한 암호화, IP암호화, 서비스 접속 암호화를 통해 보호합니다.
"회사"는 "통계 자료"를 사업의 목적으로 제 3자에게 제공할 수 있습니다. 단, 인위적 방법을 통한 가공 이전의 정보는 "회원"들의 동의 없이 제 3자에게 제공하지 아니합니다.
31. 제31 조(8세 이하의 아동 등의 보호의무자의 권리)
(1) 회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동”등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.
가) 8세 이하의 아동
나) 금치산자
다) 장애인복지법 제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진및직업재활법 제2조제2호의 규정에 의한 중증장애인에 해당하는 자(장애인복지법 제29조의 규정에 의하여 장애인등록을 한 자에 한한다)
(2) 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.
(3) 보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.
32. 제32조(위치정보관리책임자의 지정)
(1) 회사는 위치정보를 적절히 관리, 보호하고 개인위치정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수 있는 지위에 있는 자를 위치정보관리책임자로 지정해 운영합니다.
(2) 위치정보관리책임자는 위치기반서비스를 제공하는 부서의 부서장으로서 구체적인 사항은 본 약관의 부칙에 따릅니다.
33. 제 33 조 (개인정보 처리업무의 위탁)
회사는 수집된 개인정보의 처리 및 관리 등의 업무(이하 "업무")를 스스로 수행함을 원칙으로 하나, 필요한 경우 업무의 일부 또는 전부를 회사가 선정한 회사에 위탁할 수 있습니다.
제 5 장 계약해지 및 이용제한
34. 제 34 조 (계약해지 및 이용중지)
1. 회원이 다음 각 호의 행위를 하는 경우 또는 방송통신위원회 등 관계기관의 요청이 있는 경우 회사는 사전통지 없이 동 회원과의 이용계약을 해지 하거나 또는 기간을 정하여 동 회원의 본 서비스 이용을 중지할 수 있으며, 해당 게시물을 사전 통지 없이 삭제할 수 있습니다.
① 회사에서 제공하는 서비스의 저장공간에 음란물을 게재하거나 음란사이트를 링크하거나 이를 배포하는 등 사회질서를 해치는 행위
② 공공질서 또는 미풍양속에 위배되는 내용의 정보, 문장, 도형, 음성 등을 유포하는 행위
③ 타인의 명예를 훼손하거나 타인을 모욕하는 행위
④ 회사 또는 제 3자의 저작권, 지식재산권, 기타 권리를 침해하는 행위
⑤ 관계 법령에 의하여 제조, 수입, 전송 또는 게시가 금지되는 기술, 제품, 정보의 제조, 수입, 전송 또는 게시 행위
⑥ 범죄와 결부된다고 판단되는 행위
⑦ 해킹 또는 컴퓨터 바이러스를 유포하거나 타인의 의사에 반하여 광고성 정보 등 일정한 내용을 지속적으로 전송하는 행위
⑧ 다른 회원의 ID를 부정 사용하는 행위
⑨ 다른 회원의 개인정보를 수집, 도용, 저장하거나 이를 유포하는 행위
⑩ 타인을 사칭하는 행위
⑪ 서비스에 게재된 자료 및 저작물의 발신인을 위조하는 행위
⑫ 타인을 스톡(stalk)하거나 괴롭히는 행위
⑬ 정당한 사유 없이 회원 가입, 탈퇴를 수 차례 반복하여 금전적 이득을 취하거나 회사의 서비스 운영에 지장을 초래하는 행위
⑭ 본인의 ID를 타인에게 양도하거나 매매하는 행위
⑮ 서비스 운영에 지장을 주거나 줄 우려가 있는 일체의 행위 및 본 약관, 회사의 타 서비스 이용약관, 기타 관계 법령에 위배되는 행위
2. 회사는 제1항에 의해 해지된 회원이 다시 이용신청을 하는 경우 일정 기간 그 승낙을 제한하거나 이용신청을 거절할 수 있습니다.
3. 회원이 본 서비스를 해지하면, 동 회원의 본 서비스 내의 ‘회원정보’는 모두 삭제됩니다.
단, 회원이 작성한 게시물 정보는 삭제되지 않을 수 있습니다.
제 6 장 유료 서비스 이용
35. 제 35 조 (유료 서비스)
1. 회사가 제공하는 유료 서비스의 내역은 다음과 같으며, 회사는 일정기간 공지를 통하여 서비스 내용을 변경하거나 서비스의 제공을 중단할 수 있으며, 신규 서비스 또는 이벤트 상품을 추가 할 수 있습니다.
2. 회사는 유료서비스 및 개별 서비스에 대해서는 별도의 이용약관 및 정책을 둘 수 있으며, 해당 내용이 본 약관과 상충할 경우에는 그러한 별도의 이용약관 및 정책이 우선하여 적용됩니다.
36. 제 36 조 (유료 콘텐츠 및 서비스 신청) 
회원은 본 서비스상에서 다음 각 호에 따라 또는 회사가 정하는 이와 유사한 방법에 의하여 유료 콘텐츠 및 서비스 구매를 신청하며, 회사는 회원이 유료 서비스 신청을 함에 있어서 서비스에 관한 정보를 알기 쉽게 제공하여야 합니다. 단, 회원인 경우 제 2호 내지 제4호의 적용을 제외할 수 있습니다. 
① 유료 서비스의 검색 및 선택 
② 성명, 주소, 전화번호 (또는 이동전화번호), 전자우편 주소 등의 입력 
③ 약관 내용, 청약 철회권이 제한되는 서비스, 배송료 등의 비용 부담과 관련된 내용에 대한 확인 
④ 약관 동의 및 위 제3호의 사항을 확인하거나 거부하는 표시 (예, 마우스 클릭) 
⑤ 재화 등의 유료 상품 신청 및 이에 관한 확인 
⑥ 결제방법의 선택 
37. 제 37 조 (유료 콘텐츠 및 서비스 이용계약의 성립)
1. 회사는 제28조의 규정에 따른 유료 콘텐츠 및 서비스 신청이 다음 각 호의 어느 하나에 해당하면 승낙하지 않을 수 있습니다. 
① 신청 내용에 허위, 기재 누락, 오기가 있는 경우 
② 기타 유료 콘텐츠 및 서비스 신청을 승낙하는 것이 회사의 서비스 운영에 현저히 지장이 있다고 판단되거나 법령에 위반된다고 판단되는 경우 
2. 이용자가 신청서를 회사에 제출하고 결제를 한 시점에 계약이 성립한 것으로 봅니다. 
38. 제 38 조 (요금지급방법) 
1. 유료 콘텐츠 및 서비스에 대한 요금의 지급 방법은 다음 각 호의 방법 중 가능한 방법으로 할 수 있습니다.
① 신용카드 결제, 휴대폰 결제, 계좌이체, 가상계좌 입금을 통한 선불결제
② 신용카드 결제, 계좌이체를 통한 자동납부
③ 기타 회사가 인정한 수단 
2. 회사는 회원이 결제 수단을 안심하고 사용할 수 있도록 최선의 노력을 다합니다. 
39. 제 39 조 (유료 콘텐츠 및 서비스 제공의 중단 및 변경)
1. 사업 내용의 변경, 사업의 포기, 업체 간의 통합, 품절 등의 이유로 유료 콘텐츠 및 서비스를 제공할 수 없게 되는 경우 회사는 제 5조에 정한 방법으로 회원에게 통지하고 회사에서 미리 제시한 조건에 따라 회원에게 보상합니다. 
2. 유료 콘텐츠 및 서비스의 내용을 변경하는 경우 회사는 해당 유료 콘텐츠 및 서비스를 제공받거나 신청한 회원에게 제 5조에 정한 방법으로 이를 통지합니다. 이때, 회원은 계약을 해지할 수 있습니다. 이 경우 환불 등은 각 유료 콘텐츠 및 서비스 환불 절차에 따라 진행됩니다. 
40. 제 40 조 (요금 납부의 책임)
이용요금 납부 책임은 유료 콘텐츠 및 서비스 구매 계약자에게 있습니다. 단, 제3자가 요금을 납부하는 조건으로 계약자가 계약 신청을 하였을 경우에는 해당 제3자가 납부 의무를 부담하나, 제3자가 납부를 지체하는 경우 계약자도 납부 의무를 부담합니다.
41. 제 41 조 (요금의 반환) 
1. 회사는 요금 등의 과오납이 있을 때에는 그 과오납 요금을 반환합니다. 단, 회원이 동의하거나 회사의 반환통지에 대하여 응하지 아니할 경우에는 익월 요금 청구시 해당 요금을 차감하여 청구할 수 있습니다. 
2. 회사는 요금 등을 반환하여야 할 회원에게 미납 요금 등이 있을 경우에는 반환하여야 할 요금 등과 미납 요금 등을 상계 처리할 수 있습니다. 
42. 제 42 조 (청약철회 및 환불)
1. 회원은 구매한 유료 콘텐츠에 대하여 계약 체결일 또는 유료 콘텐츠 이용가능일로부터 7일 이내에 별도의 수수료 없이 청약철회(구매취소)를 할 수 있습니다. 단, 선물 및 이벤트 등으로 회사나 제3자로부터 무상으로 제공받은 유료 콘텐츠, 청약철회 요청 당시 이미 사용하였거나 사용한 것으로 간주되는 유료 콘텐츠 등 이에 준하는 특성을 가진 일부 유료 콘텐츠에 대하여는 전자상거래 등에서의 소비자보호에 관한 법률 제17조 제2항 제2호 내지 제3호 및 온라인 디지털콘텐츠산업 발전법 제16조의2에 따라 청약철회(구매취소)가 제한될 수 있습니다. 이에 해당하는 경우 회사는 회원이 해당 유료 콘텐츠를 구매할 때 제한 사실을 고지하는 등 관련 법률에서 정한 바에 따른 조치를 취합니다.
2. 회사의 귀책사유로 인하여 회원이 구매한 유료 콘텐츠를 이용하지 못하는 경우, 회사는 동일한 유료 콘텐츠를 무상으로 제공하거나 해당 구매 금액을 계약체결일(구매일)에 관계없이 전액 환불합니다. 
3. 환불은 서비스를 이용하고 있는 단말기의 운영체제 종류에 따라 각 앱스토어 사업자의 환불 운영정책에 따라 진행되며, 자세한 환불 신청 절차는 회사 홈페이지 상에 공지된 바에 따릅니다. 또한 환불된 금액에 따라 유료 콘텐츠는 해당 환불된 금액만큼 차감하여 제공됩니다.
4. 유료 콘텐츠를 기초로 무료 콘텐츠를 획득한 경우 및 유료 콘텐츠의 전체 혹은 일부 사용으로 인하여 구매할 수 있는 기본 단위가 훼손된 경우 회사는 회원이 이용 의사를 밝힌 것으로 간주합니다. 또한, 메시지함 및 선물함 등 유료 콘텐츠의 송수신과 관련된 화면에서 수락 등의 동의 과정을 거친 경우 이용자가 이용 의사를 밝힌 것으로 간주합니다. 이는 고객의 의도와 상이하게 타인을 통해 구매되었을 경우에도 같습니다.
5. 회원이 실제 정상적인 구매 내역이 기록되는 이용대금의 결제를 통하지 않고 서비스 이용 중에 보상으로 취득하거나 회사가 내부 이벤트 혹은 외부 제휴 이벤트 등을 통하여 지급한 유료 콘텐츠는 환불하지 않습니다.
6. 회원이 청약철회 및 환불 등을 요구할 경우에는 회사 고객센터 및 회사가 지정한 위탁업체에서 별도의 개인정보 처리에 대한 동의 과정을 거친 후 회사의 구매내역 확인에 의해 진행되며, 이 과정 중 플랫폼 사업자 또는 앱스토어 사업자를 통해 구매내역을 확인하는 절차를 거친 다음 진행됩니다. 회사는 이 과정 중에서 회원의 정당한 철회 사유를 확인하기 위해 회원에게서 제공받은 정보를 통해 회원에게 연락하여 정확한 사실 확인을 할 수 있으며, 추가적으로 증빙을 요구할 수 있습니다. (예: 플랫폼 사업자에게 등록된 개인정보, 앱스토어의 구매 또는 결제내역, 고객의 의도와 상이하게 타인을 통해 구매되었다는 것을 확인할 수 있는 서류(가족관계 증명) 등)
7. 다음과 같은 경우 청약철회가 제한되며 회사는 회원의 결제 전에 청약철회가 제한됨을 표시합니다.
① 구매 후 즉시 사용이 시작되거나 즉시 애플리케이션에 적용되는 유료 콘텐츠의 경우
② 애플리케이션의 정상적인 이용과정에서 결제 없이 획득한 유료 콘텐츠 의 경우
③ 추가적인 혜택이 제공되는 유료 콘텐츠 에서 해당 추가 혜택이 사용된 경우
④ 묶음형으로 판매된 유료 콘텐츠 의 일부가 사용된 경우
⑤ 개봉행위를 사용으로 볼 수 있거나 개봉 시 효용이 결정되는 유료 콘텐츠 의 경우
8. 애플리케이션에서 판매되는 유료 콘텐츠를 미성년자가 법정대리인의 동의 없이 결제한 경우, 미성년자 또는 법정대리인은 결제를 취소할 수 있습니다. 단, 미성년자의 결제가 법정대리인으로부터 처분을 허락 받은 재산의 범위 내인 경우 또는 미성년자가 사술 등을 사용하여 성년자로 믿게 한 때에는 취소가 제한됩니다. 유료 콘텐츠 구매자가 미성년자인지 여부는 결제가 진행된 단말기 또는 신용카드 등 결제수단의 명의자를 기준으로 판단됩니다. 미성년자 결제 취소를 요청하는 경우 회사의 필요에 따라 미성년자 및 법정대리인임을 증명할 수 있는 서류를 제출하여야 합니다.
9. 유료 콘텐츠 구매 결제는 오픈마켓사업자가 제공하는 결제방식에 따릅니다. 따라서 결제 과정에서 과오금이 발생하는 경우 원칙적으로 오픈마켓사업자에게 환급을 요청하여야 합니다. 단, 오픈마켓사업자의 정책, 시스템에 따라 가능한 경우 회사가 오픈마켓사업자에게 필요한 환급절차의 이행을 요청할 수도 있습니다.
10. 선물하기 기능을 통하여 이루어진 구매에 대하여는 구매한 유료 콘텐츠에 하자가 있는 경우를 제외하고는 원칙적으로 청약철회 및 환불이 불가하며, 유료 콘텐츠의 하자로 인한 환불은 선물을 보낸 회원에 대하여만 가능합니다.
43. 제 43 조 (서비스 제공 및 중지)
1. "회원"은 "회사"가 제공하는 서비스에 대해 언제든지 사용 여부를 결정할 수 있으며, "회사"는 "회원"의 서비스 사용 의사가 없을 경우 서비스 제공을 중지합니다.
2. "회사"가 제공하는 서비스는 다음과 같습니다.
•	서비스	항목 및 서비스 내용
①	병원예약 서비스 :	접수/예약 서비스	모바일로 병•의원의 진료를 접수하거나 예약이 가능하며 회원 위치를 기반으로 한 병원/약국 찾기 제공 서비스
②	대기현황 서비스	: 접수 또는 내원한 병•의원의 진료 대기순번을 안내해주는 편의 서비스
③	결제 서비스 :	"회원"이 결제 카드를 등록하여 모바일로 진료비를 결제하고 개인진료기록 및 제증명 서류를 발급받을 수 있는 서비스
④	전화예약진료 :	“회원”이 병•의원을 직접 방문하지 않고도 전화 상담 또는 처방을 받을 수 있는 서비스 (보건복지부 공고 제2020-177호 "전화상담 또는 처방 및 대리처방 한시적 허용방안"에 의거)
⑤	제증명서류 서비스 : “회원”이 유무선기기를 통해 병.의원에서 발급하는 서류를 신청하고 보험회사에 청구를 연결하는 서비스
⑥	기타 서비스 :	"회사"가 추가 개발하거나 제휴 제작 건강 컨텐츠를 비롯하여 다른 회사와의 제휴 계약 등을 통해 제공하는 "기타 서비스"
2. "회사"는 다음 각호에 해당하는 경우 서비스의 제공을 중지할 수 있습니다.
①	설비의 보수 등을 위하여 부득이한 경우
②	전기통신 사업법에 규정된 기간통신 사업자가 전기 통신서비스를 중지하는 경우
③	천재지변 등으로 인해 서비스제공자가 불가피하게 서비스를 제공할 수 없는 사유가 발생한 경우
④	회원이 이용해지를 요청한 경우
3. 회원의 폐업/휴업 등을 포함하여, 회원의 사유로 인해 1개월 이상 서비스 이용이 중지된 경우 이 경우 "회사"는 제13조 "회원"에 대한 통지에 정한 방법으로 "회원"에게 통지합니다. 다만, "회사"가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
4. "회사"는 서비스제공자의 경영, 정책, 운영 그리고 기술상의 이유로 무료로 제공되는 서비스의 전부 또는 일부를 변경(유료화 포함) 또는 중단할 수 있으며, 이에 대하여 관련 법에 특별한 규정이 없는 한 회원에게 별도의 보상을 하지 않습니다.
5. 본 조에 의해 서비스가 변경 또는 중단되는 경우에는 그 변경 또는 중단 사실을 서비스 페이지 내에 적용일 14일전부터 게시하여 공지합니다.
6. 회사는 "서비스"를 일정범위로 분할하여 각 범위 별로 이용가능시간을 별도로 지정할 수 있습니다. 다만, 이러한 경우에는 그 내용을 사전에 공지합니다.
7. "서비스"는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.
"회사"는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스제공화면에 공지한 바에 따릅니다.
8. 회사"는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 "서비스"를 본 계약에서 정한 범위 내에서 변경할 수 있습니다.
9. "서비스"의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등은 그 변경 전에 해당 서비스 초기화면에 게시하여야 합니다.
제 7 장 쇼핑몰 이용
44. 제 44 조 (사용 가능한 결제 수단)
쇼핑몰에서 구매한 상품 등에 대한 대금지급방법은 다음 각 호의 하나로 할 수 있습니다. 
① 신용카드 결제
② 핸드폰 결제
③ 무통장 입금
④ 기타 판매중개자가 추가 지정하는 결제 수단
45. 제 45 조 (상품교환권 구매)
1. 상품교환권의 가격은 판매자가 정하고 상품 등의 가격 및 상세 정보는 판매자가 제공하며, 
회사는 판매자의 상품 등 가격 결정 등에 대하여 일절 관여하지 아니합니다. 
2. 회원은 쇼핑몰에서 다음 각 호에 따른 절차 또는 판매중개자가 정하는 이와 유사한 방법에 의하여 구매를 신청합니다. 단, 판매중개자는 회원등록이 되어 있는 구매자에게 제 1호의 적용을 제외할 수 있습니다.
① 성명, 주소, 이동전화번호, 전자우편주소 등의 입력
② 재화 또는 용역의 선택
③ 결제 방법의 선택
④ 약관에 동의한다는 표시
46. 제 46 조 (상품교환권 전송)
1. 판매중개자는 구매자가 구매한 상품교환권에 대해 전송방법, 전송시각 등을 명시합니다. 만약 판매중개자의 고의, 과실로 약정 전송기간을 초과한 경우에는 그로 인한 구매자의 손해를 배상합니다.
2. 전송 소요 기간은 결제한 후 해당 서비스가 정한 개별 조건상의 전송일에 한하여 1일 이내에 전송하며, 전송작업은 공휴일과 판매중개자가 쉬는 날 및 처리 과정의 상황에 따라 변경될 수 있으며, 이는 사이트 이용 방법에 명시된 내용을 따릅니다.
47. 제 47 조 (상품교환권의 사용)
1. 구매자는 개별조건 상에 명시된 유효 기간 내에 한해서만 상품교환권을 사용하여 판매자의 상품 등을 제공받을 수 있습니다. 유효 기간이 만료된 상품교환권은 사용할 수 없으며 환불이 불가합니다.
2. 구매자는 쇼핑몰에 명시된 내용 및 개별 주의사항(이용조건)을 확인하여야 할 책임이 있으며, 
명시된 이용조건에 따라서만 상품교환권을 사용하실 수 있습니다.
3. 구매자가 상품 등의 내용과 거래 조건을 확인하지 않고 상품 등을 구매하여 발생한 모든 손해에 대한 책임은 회원 본인에게 있고, 회사는 판매자가 제공한 상품 등의 가격 및 정보 내용, 기타 교환, 환불 등에 대하여 책임을 지지 아니합니다. 
48. 제 48 조 (구매 상품교환권에 대한 취소, 환불 등)
1. 판매중개자의 상품교환권 구매 취소 및 환불 규정은 『전자상거래 등에서의 소비자보호에 관한 법률』 등 관련 법령을 준수합니다.
2. 판매자와 상품 등의 구매에 관한 계약을 체결한 구매자는 수신확인의 통지를 받은 날부터 7일 이내에는 청약의 철회를 할 수 있습니다.
3. 구매자는 상품 등을 배송 받은 경우 아래 각호의 1에 해당하는 경우에는 반품 및 환불, 교환을 할 수 없습니다.
① 구매자에게 책임 있는 사유로 상품 등이 멸실 또는 훼손된 경우
② 구매자의 사용 또는 일부 소비에 의하여 상품 등의 가치가 현저히 감소한 경우
③ 시간의 경과에 의하여 재판매가 곤란할 정도로 상품 등의 가치가 현저히 감소한 경우
4. 구매자는 제2항 및 제3항의 규정에도 불구하고 상품 등의 내용이 표시, 광고 내용과 다르거나 계약 내용과 다르게 이행된 때에는 당해 상품 등을 공급받은 날부터 3월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30 일 이내에 청약철회 등을 할 수 있습니다.
5. 신용카드 결제 이용자의 경우 구매 취소 시 기존에 결제하였던 내역을 취소하며 취소 시점에 따라 예매 취소 수수료를 재 승인 합니다. 이 경우 판매중개자는 구매자의 동의를 구한 후 재 승인을 하며, 구매 취소 시점과 해당 카드사의 환불 처리기준에 따라 취소금액의 환급 방법과 환급 일은 다소 차이가 있을 수 있으며, 사용한 신용카드의 환불 정책은 신용카드회사에 직접 문의하여야 합니다.
6. 구매자의 구매 상태는 사이트를 통해 조회 가능해야 하며, 입금 후 취소 또는 전체 환불 할 경우 정상 처리 결과에 대해 제17조 제2항에 정한 방법으로 통지합니다.
7. 구매자의 단순 변심에 의한 취소일 경우 환불처리에 발생하는 수수료는 구매자가 부담합니다.
8. 기타 본 약관 및 사이트의 이용안내에 규정되지 않은 취소 및 환불에 대한 사항에 대해서는 소비자 피해보상규정에서 정한 바에 따릅니다.
49. 제 49 조 (데이터 수집 및 사용 )
1. 회사는 제품의 품질개선 및 사용에 대한 효과를 최대화 하기 위하여 사용자의 시스템 정보(운영 체제 정보, 제품의 정보, 에러 정보, 전화번호, 이메일)등의 정보를 수집할 수 있습니다.
2. 회원이 동의한 개인진료기록에 대한 데이터는 케어포미.APP와 사용자의 핸드폰에 저장되며, 회원의 탈퇴 시, 케어포미.APP에서는 데이터가 삭제되지만, 병원에 공유된 환자 기록은 의료법에 입각하여 보관됩니다. 병원에 공유된 환자 기록은 병원에서 관리하고 보관할 의무를 가지고 있습니다. 단, 사용자가 핸드폰에 저장한 데이터에 대해서는 책임지지 않습니다. 
3. 회사의 운영에 따라 광고가 개제 될 수 있습니다. 또한, 광고 통계 수집을 위해 광고노출 수와 클릭 수를 수집할 수 있습니다.
50. 제  50조 (판매중개자 및 판매자의 취소에 대한 특칙)
1. 판매중개자와 판매자는 판매 중인 상품 등에 중대한 결함이나 문제 발생 또는 그 발생이 예상되는 경우 판매중인 상품 등의 판매를 취소할 수 있습니다.
2. 전1항의 이유로 판매가 취소되는 경우 판매중개자는 상품교환권을 사용하지 않은 해당 상품 등의 기 구매자에 대하여 환불을 진행합니다.
3. 상품교환권을 사용한 구매자의 경우 판매자의 서비스 제공에 중대한 결함이 있는 것이 아니고 서비스를 지속할 수 있다고 판단되는 경우 환불을 진행하지 않으며, 판매자의 서비스 제공에 중대한 결함이 발생하여 서비스가 중단되는 경우에는 아래 제 39 조의 3 의 약관에 따라 환불 및 보상을 진행합니다. 
51. 제 51 조 (판매자의 서비스 중단에 대한 특칙)
1. 판매중개자는 판매자가 폐업 등의 이유로 구매자에게 제공해야 할 서비스가 제공되지 못한 상황이 발생하는 경우 판매자에게 판매 대금 지급이 되지 않은 건에 대하여 판매중개자가 구매자에게 환불을 진행 합니다.
2. 단, 구매자의 서비스 이용 중 판매자의 폐업 등의 이유로 구매자에게 제공해야 할 서비스가 제공되지 못한 상황이 발생하는 경우 판매중개자는 구매자의 서비스 기 사용 분을 차감한 금액(회원권의 경우 남은 일수만큼의 일할 계산, 웹사이트의 포인트, 적립금의 경우 사용금액을 차감하여 남은 금액)을 환불합니다. 
3. 전2항의 경우에서 만약 판매중개자가 판매자를 통한 구매자의 사용 내역 확인이 불가능할 경우에는 남은 상품 교환권 유효기간 일수만큼을 일할 계산하여 환불합니다. 
52. 제 52 조 (상품의 지식재산권)
1. 판매자가 쇼핑몰을 통해 판매하는 상품 등의 저작권 및 기타 지식재산권은 판매자 본인에게 있으며, 해당 상품 등이 타인의 저작권, 기타 권리를 침해하는 경우 그에 대한 책임은 판매자가 부담합니다. 
2. 구매자는 쇼핑몰을 통해 판매자로부터 상품교환권을 구매하는 것이며, 상품 등의 저작권, 기타 지식재산권을 구매하는 것이 아닙니다. 따라서 구매자가 판매자의 명시적인 허락 없이 상품 등 또는 상품교환권을 무단 복제 하거나 전송하는 등 판매자의 저작권, 기타 지식재산권을 침해하는 행위는 허용되지 않습니다. 
3. 구매자는 구매한 상품 등 또는 상품교환권을 가공, 재판매, 홍보 등 영리목적으로 이용하거나 제3자에게 이용하게 할 수 없습니다.
제 8 장 손해배상 및 면책
53. 제 53 조 (손해배상 범위)
1. 회사의 귀책사유로 회원이 유료 서비스를 이용하지 못하는 경우, 회사는 이에 대한 손해를 배상합니다. 다만, 제39조의 2, 제39조의 3의 경우와 회원이 이용 불가 사실을 회사에 접수한 이후 2시간 이내 정상화된 경우는 제외합니다. 
2. 손해배상 대상은 회사와 유료 서비스 이용계약이 체결된 서비스에 한합니다. 
54. 제 54 조 (면책조항)
1. 회사는 다음 각 호의 1에 해당하는 경우에는 책임이 면제되며 손해배상을 하지 않습니다.
① 전시, 사변, 천재지변 또는 이에 준하는 국가비상사태 등 불가항력으로 서비스를 제공할 수 없는 경우
② 전기통신서비스 특성상 불가피한 사유로 서비스 제공이 불가능하거나 관련 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 일시적으로 서비스 제공을 중단하는 경우
③ 회원의 고의, 과실 또는 서비스 미숙지 등 귀책 사유로 서비스 이용의 장애, 회원정보 또는 자료의 소실 또는 손해가 발생한 경우
④ 회원이 신상정보 및 전자우편 주소를 부실하게 기재하여 손해가 발생한 경우
⑤ 회원이 자신의 아이디/비밀번호를 타인에게 알려주어 회원에게 어떠한 손해가 발생한 경우
⑥ 회원이 서비스를 이용하여 얻을 수 있을 것으로 기대하는 손익이나 서비스를 통해 얻은 정보 및 자료 등으로 인해 발생한 손익의 경우
⑦ 회원 상호간 및 회원과 제 3자 상호 간에 서비스를 매개로 분쟁 및 손해가 발생한 경우
⑧ 회원이 자료를 게시, 전송, 저장, 조회함으로써 법적인 책임이 발생한 경우
⑨ 회원의 컴퓨터 오류, 인터넷 접속장애로 서비스가 지연되거나 수행되지 않은 결과에 대해서 회원에게 발생한 손해의 경우
⑩ 기타 무료로 제공되는 서비스에 대하여 회원에게 어떠한 손해가 발생한 경우
⑪ 회원이 다른 회원이 게재한 정보, 자료, 사실의 정확성 등을 신뢰함으로써 손해를 입은 경우 
2. 회사의 서비스와 피 연결회사(회사의 서비스 화면과 링크 등으로 연결된 사이트를 운영하는 회사를 말합니다)의 서비스는 상호 독자적으로 운영되며, 회사는 피 연결회사와 회원간에 이루어진 거래에 대하여는 책임 지지 않습니다.
55. 회사 연락처
1. 상 호 : 주식회사 미라벨소프트
2. 대 표 자 : 박기호
3. 주 소 : 서울특별시 서초구 효령로 304 국제전자센터 11층 11054호
4. 대표전화 : 1877-4872
56. 제 55 조 (준거법, 관할법원)
1. 본 약관에 관하여 분쟁이 발생할 경우 대한민국의 법률에 따릅니다.
2. 이 약관에 명시되지 않은 사항은 상법, 전기통신사업법, 전자상거래 등에서의 소비자 보호에 관한 법률 등 기타 관계법령과 상관습에 따릅니다. 
3. 서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는 경우 회원 또는 회사의 주소지 관할법원을 제 1심 합의관할 법원으로 합니다.
[부칙] 
제1조 이 약관은 2020년 06월 01일부터 적용됩니다.
                    `}
          </pre>
        </div>
      </div>
    </div>
  );
};
